<script setup lang="ts">
import Avatar from "@/design/primitives/Avatar.vue";
import { useFileSrc } from "./use-file-src";

/**
 * O rosto de alguém, a partir do ID do arquivo.
 *
 * ── POR QUE ISTO EXISTE, SE O `Avatar` JÁ EXISTE ──────────────────────────
 *
 * Porque um primitivo de `design/` não fala com a rede, e resolver um id de arquivo
 * num endereço é uma consulta. Esta casca de dez linhas é onde as duas coisas se
 * encontram: o primitivo continua sem saber de porta nenhuma, e a tela continua sem
 * montar URL na mão.
 *
 * ── E POR QUE ELA É UM COMPONENTE E NÃO UMA CHAMADA NA TELA ───────────────
 *
 * Por causa da LISTA. Um composable não pode ser chamado dentro de um `v-for`, e a
 * lista de Equipe desenha uma pessoa por linha. Um componente por linha resolve o
 * endereço de cada uma sem que a página precise montar um mapa de ids.
 */
const props = withDefaults(
	defineProps<{
		name?: string | null;
		fileId?: string | null;
		size?: "xs" | "sm" | "md" | "lg";
		/**
		 * A cor de quem não tem foto — repassada ao primitivo tal como chega.
		 *
		 * Existe porque as LISTAS a usam: a de contatos, a da caixa de entrada e o
		 * cartão do funil desenham a inicial numa cor derivada de um id estável, e
		 * sem isto trocar `Avatar` por este componente apagaria a cor de todas elas.
		 */
		seed?: string | null;
		class?: string;
	}>(),
	{ name: null, fileId: null, size: "md", seed: null, class: "" },
);

const src = useFileSrc(() => props.fileId);
</script>

<template>
	<Avatar
		:name="props.name"
		:src="src"
		:size="props.size"
		:seed="props.seed"
		:class="props.class"
	/>
</template>
